<template>
    <fragment>
        <v-col cols="12" md="6" class="pb-5">
            <v-switch
                class="pa-0 ma-0 justify-self-center d-inline-block"
                inset
                hide-details
                dense
                color="secondary"
                v-model="ativo"/>
            <p class="pl-1 mb-0 d-inline-block darkBluishGray--text body-2">
                {{ statusSwitch }}
            </p>
        </v-col>
        <v-col cols="12" md="6" class="pb-5">
            <BaseButton
                v-if="allowAdd"
                min-width="200"
                class="secondary"
                style="float:right"
                @click="addBrokerClick">
                <v-icon class="pr-4 add-icon">fa-plus</v-icon>
                INCLUIR CORRETORA
            </BaseButton>
        </v-col>
        <v-row v-if="ativo">
            <fragment v-for="(item, index) in form.items"
                :key="index">
                <v-col cols="12" md="4">
                    <BaseFormSelect
                        id-element="corretora"
                        placeholder="Selecionar"
                        :return-object="true"
                        required
                        :rules="[validateBroker]"
                        v-model="form.items[index].corretora"
                        :items="getOptions(index)"
                        validate-on-blur
                        label-text="Corretora"/>
                </v-col>
                <v-col cols="12" md="4" class="pl-md-5">
                    <BaseFormInput
                        placeholder="Inserir valor"
                        v-model="item.participacao"
                        required
                        :rules="[greaterThanZero, validParticipation]"
                        type="number"
                        validate-on-blur
                        label-text="Perc. Participação"/>
                </v-col>
                <v-col cols="12" md="4" class="pl-md-5">
                    <BaseButton v-if="allowRemove"
                        class="mt-8 error"
                        @click="removeBrokerClick(index)">
                        <v-icon class="add-icon">fa-minus</v-icon>
                    </BaseButton>
                </v-col>
            </fragment>
        </v-row>
    </fragment>
</template>
<script>
/*this.$store é o store do objeto pai, nesse caso, @/modules/economic_group/store/index.js*/
import { api } from "@/api";
import {
  requiredInput,
  greaterThanZero
} from "@/utils/rules.js";
export default {
  name:"CoBrokeringSelection",

  data: () => ({
    requiredInput,
    greaterThanZero,
    api,
    allOptions:[]
  }),

  async created() {
    if(this.form == null) {
      let payload = {
        grupo_economico: this.economic_group.id,
        limite_credito: this.$route.params.consultId
      };
      
      this.$store.dispatch('economic_group/fetchCoBrokering', payload);
    } 
    
    await this.fetchOptions();
  },
  props: { 
      economic_group: Object
  },
  computed: {
    statusSwitch() {
        return this.ativo? "Ativo" : "Inativo";
    },

    allowRemove() {
        return this.form.items.length > 2;
    },

    allowAdd() {
        return this.ativo && this.form.items.length < this.allOptions.length;
    },

    form() {
        return this.$store.getters["economic_group/coBrokering"](this.economic_group.id, this.$route.params.consultId);
    },

    ativo: {
        get: function() {
            return this.form ? this.form.ativo : false;
        },
        set: function(value) {
            if(this.form != null) {
                this.form.ativo = value;
            }
        }
    }
  },

  watch: {
    form: {
        handler: function(value) {
            this.$store.commit('economic_group/setCoBrokering', value);
        },
        deep: true
    }
  },

  methods: {
    async fetchOptions() {
        var data = (await this.api.get("/v1/corretorasativas")).data;
        if(data == null){
            return;
        }
        var options = [];
        for(let i = 0; i < data.length; i++) {
            options.push({
                text: data[i].nome,
                value: data[i].id,
                disabled: false
            });
        }

        this.allOptions = options;
    },

    getOptions(itemIndex) {
        let options = [];

        // desabilita opções selecionadas nos demais selects
        for(let i = 0; i < this.form.items.length; i++) {
            if(i == itemIndex) {
                continue;
            }

            let optionIndex = this.allOptions.findIndex(option => option.value == this.form.items[i].corretora.value);
            if(optionIndex >= 0) {
                options[optionIndex] = {
                    text: this.allOptions[optionIndex].text,
                    value: this.allOptions[optionIndex].value,
                    disabled: true
                }
            }
        }

        // deixa as demais opções habilitadas
        for(let i = 0; i < this.allOptions.length; i++) {
            if(options[i] == null) {
                options[i] = {
                    text: this.allOptions[i].text,
                    value: this.allOptions[i].value,
                    disabled: false
                }
            }
        }

        return options;
    },

    addBrokerClick() {
        let newItem = {
            corretora: { value: "" },
            participacao: 0.0
        };

        this.form.items.push(newItem);
    },

    removeBrokerClick(itemIndex) {
        this.form.items.splice(itemIndex, 1);
    },

    validateBroker(broker) {
        if(broker != null && broker.value != null && broker.value.length > 0) {
            return true;
        }
        else {
            return "Este campo é obrigatório.";
        }
    },

    validParticipation() {
        let totalPartic = 0;
        for(let i = 0; i < this.form.items.length; i++) {
            totalPartic += Number.parseFloat(this.form.items[i].participacao);
        }

        if(totalPartic != 100) {
            return "A soma das participações das corretoras deve totalizar 100";
        }
        
        return true;
    }
  }
};
</script>
